import { useTranslation } from "react-i18next";

export interface ModulePlaceholderScreenProps {
  /** Namespaced i18n key for the screen's display name, e.g. "alerts:nav.alerts". */
  readonly titleKey: string;
}

/**
 * A screen for a permission the backend grants but whose real UI has not been
 * built yet. Renders only the screen's name — no data, no actions — so the
 * feature is reachable and its permission is grantable in the roles matrix
 * without pretending the feature has behaviour it doesn't have.
 */
export function ModulePlaceholderScreen({
  titleKey,
}: ModulePlaceholderScreenProps) {
  const { t } = useTranslation();
  const title = t(titleKey);

  return (
    <main className="animate-rise flex flex-col gap-4 p-3 md:p-4">
      <h1 className="sr-only">{title}</h1>
      <header className="flex flex-col gap-1">
        <p className="text-heading-h5-semibold text-text">{title}</p>
      </header>
    </main>
  );
}
